import ContactFooter from "components/ContactFooter";
import OnlyImportant from "features/Landing/components/OnlyImportant";
import ImageWithTexts from "features/Landing/components/ImageWithTexts";
import appExample from "assets/images/app-atualizado.png";
import { Container, ContentContainer, Section, SectionInner } from "./styles";
import Hero from "features/Landing/components/Hero";
import CoursesComponent from "features/Landing/components/Courses";
import MobileStore from "assets/images/mobileStore.png";
import AboutSection from "features/Landing/components/About";

export let Courses;
export let App;
export let About;
export let Users;
export let Contact;

const Landing = () => {
  return (
    <Container>
      <ContentContainer>
        <Hero />

        <Section
          id="cursos"
          ref={(section) => {
            Courses = section;
          }}
        >
          <SectionInner>
            <CoursesComponent />
          </SectionInner>
        </Section>

        <Section
          tinted
          ref={(section) => {
            About = section;
          }}
        >
          <SectionInner>
            <AboutSection />
          </SectionInner>
        </Section>

        <Section
          ref={(section) => {
            App = section;
          }}
        >
          <SectionInner>
            <ImageWithTexts
              reverse
              maxWidth
              image={appExample}
              bottomTextImg={MobileStore}
              titles={[
                "A Studium possibilita acesso na palma da sua mão.",
                "Com aplicativo e site, você aprende quando e onde quiser!",
              ]}
              maxWidthValue="100%"
            />
          </SectionInner>
        </Section>

        <Section tinted>
          <SectionInner>
            <OnlyImportant />
          </SectionInner>
        </Section>
      </ContentContainer>

      <section
        ref={(section) => {
          Contact = section;
        }}
        id="contact"
      >
        <ContactFooter />
      </section>
    </Container>
  );
};

export default Landing;
